module.exports = __webpack_public_path__ + "static/media/9.jpg.2e0c22e0.webp";